import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { ReactNode } from 'react';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
  children?: ReactNode;
};

export function ThreeUpSectionBox({ gridCard, children }: Props) {
  return <group position={[0, gridCard.worldPosition.y, 0]}>{children}</group>;
}
